import React, { useContext, useEffect, useRef, useState } from "react";
import { authorize3dsCharge } from "../../services/api.services";
import { useViewContext } from "../../contexts/view.context";
import { useUrlAuthContext } from "../../contexts/urlauth.context";
import { useUrlBodyContext } from "../../contexts/urlBody.context";
import {
  PaymentContext,
  PaymentContextValue,
  PaymentStage,
} from "../../contexts/Payment/payment.context";
import { handleAuthModelStage } from "../../utils/helpers";
import CancelButton from "../../assets/img/cancel.svg";
import { usePayDataContext } from "../../contexts/PayDataContext";

export default function Card3DS() {
  const {
    state,
    setState,
    setStage,
    setError,
    setPaymentReference,
  }: PaymentContextValue = useContext(PaymentContext);
  const formRef = useRef(null);
  const [show, setShow] = useState(false);
  const { view, setView } = useViewContext();
  const { urlAuth, setUrlAuth } = useUrlAuthContext();
  const { urlBody, setUrlBody } = useUrlBodyContext();
  const [loading, setLoading] = useState(false);
  const [authReference, setAuthReference] = useState("");
  const { merchantData } = usePayDataContext();

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    try {
      const charge = await authorize3dsCharge(authReference);
      const { status, message, auth_model } = charge;
      setState({ charge });
      let stage = PaymentStage.init;
      if (status === "Successful") {
        setStage(PaymentStage.success);
        setPaymentReference(charge.reference);
        setView("success");

        if (merchantData.meta.redirect_url) {
          setTimeout(() => {
            window.location.href = merchantData.meta.redirect_url;
          }, 2000);
        }
        return;
      } else if (status === "Failed") {
        setError(message);
        setView("error");
      } else {
        stage = handleAuthModelStage(auth_model);
        !stage && setError(charge.message);
      }
    } catch (e) {
      setView("error");
      setLoading(false);
    }
  };

  useEffect(() => {
    setAuthReference(state.charge.reference);
    if (urlAuth || urlAuth) {
      // Submit the  for 3DS authentication if formUrl is available
      if (urlAuth) {
        formRef.current?.submit();
        setShow(true);
      }
    } else {
      setView("error");
    }

    window.addEventListener("message", (event) => {
      if (
        event.origin !== "https://checkout.sarepay.com" ||
        "https://staging-app.sarepay.com" ||
        "https://app.sarepay.com"
      ) {
        return;
      }
    });
  }, []);
  return (
    <>
      <div className="fixed top-0 left-0 z-10 bg-white w-screen h-screen">
        <div
          className="flex items-center gap-2 pt-5 pl-5"
          onClick={handleSubmit}
        >
          <img src={CancelButton} alt="CancelIcon" />
          <span className="text-[#101828] font-semibold">Click <span className="text-[var(--SarepayPrimary-color)]">here</span> to close this page.<br /> (Please do NOT close this browser tab.) </span>
        </div>
        <iframe
          title={"3ds"}
          srcDoc={urlBody}
          className="w-full h-full"
          sandbox="allow-forms allow-scripts allow-same-origin allow-popups"
        ></iframe>
      </div>
    </>
  );
}
